function limitCheckbox() {
  const checkboxesToLimit = document.querySelectorAll('[data-checkbox-limit]');

  checkboxesToLimit.forEach((checkbox) => {
    checkbox.addEventListener('change', () => {
      if (!checkbox.dataset.checkboxLimit) return;

      const checkboxUncheckedFamily = document.querySelectorAll(
        `input[name="${checkbox.name}"]:not(:checked)`
      );
      const checkboxCheckedFamily = document.querySelectorAll(
        `input[name="${checkbox.name}"]:checked`
      );
      const limit = checkbox.dataset.checkboxLimit;

      if (checkboxCheckedFamily.length < limit) {
        checkboxUncheckedFamily.forEach(
          (unchecked) => (unchecked.disabled = false)
        );

        return;
      }

      checkboxUncheckedFamily.forEach(
        (unchecked) => (unchecked.disabled = true)
      );
    });
  });
}

export default limitCheckbox;
